import { ReactNode } from "react"
import { navigate, Link } from 'gatsby-link'
import { NavigateOptions, globalHistory } from '@reach/router'
import { SmoothScroll } from "../../utility/smoothScroll"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { ModalMenuState } from "../../status/ModalMenuState"
import { useTransition } from "../layouts/TransitionLayout"
import { LanguageState } from "../../status/LanguageState"
// import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
// import { modalMenuState } from '@states/modal-menu-state'

// import { useStore } from '@hooks/useStore'
const MyLink = ({
	children,
	to,
	blank,
	scroll,
	onClick,
	isStopPropagation,
	...other
}: {
	className?: string
	children: any
	to: string
	blank?: boolean
	scroll?: string
	onClick?: any
	isStopPropagation?: boolean
}) => {
	let language = useRecoilValue(LanguageState)
	let [isModalMenu, setIsModalMenu] = useRecoilState(ModalMenuState)
	const { transitionState, setTranstionState, duration } = useTransition() as any

	let isInternal = /^\/(?!\/)/.test(to)
	let isHash = /^(!?#)/.test(to)
	let languageTo = `${language === "ja" ? "" : "/en"}${to}`
	// const { appStore } = useStore()

	if (isHash || scroll) {
		isInternal = true
	}

	const { location } = globalHistory

	const onClickHandler = (e:any) => {
		isStopPropagation && e.stopPropagation()
		e.preventDefault()
		if( transitionState !== 0){ return }

		if ( (location.pathname === languageTo) || (location.pathname === `${languageTo}/`) || !languageTo) {
			if (scroll) {
				// console.log(scroll)
				onClick && onClick()
				SmoothScroll(scroll)
			} else {
				onClick && onClick()
				SmoothScroll('#root')
			}
			return
		} else {

			onClick && onClick()
			setTranstionState(1)
			if( isModalMenu === true){
				setIsModalMenu(false)
			}
			setTimeout(() => {
				navigate(languageTo)
				if (scroll) {
					setTimeout(() => {
						SmoothScroll(scroll)
					}, 1000)
				}
			}, 1 * 1000)
		}
	}

	// useEffect(()=>{
	// })
	
	return (
		<>
		{ isInternal ?
				<Link
					to={languageTo}
					onClick={onClickHandler}
					{...other}
				>
					{children}
				</Link>
			:
				<a href={to} target={blank ? "_blank" : ""} {...other}>
					{children}
				</a>
		}
		</>
	)
}

const MyNavigate = (path:string) => {
	// let modalMenuValue = useRecoilValue(modalMenuState)
	const { transitionState, setTranstionState, duration } = useTransition() as any
	setTranstionState(1)
	console.log(path)
	navigate(path)
}

export { MyLink, MyNavigate }